import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
} from "@mui/material";
import { isEmpty } from "lodash";
import { ReactComponent as SmallDhiramIcon } from "../../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../../utils/CurrencyUtils";
import { formattedAmountWithoutAed } from "../../../../../utils/CommonFunction";
import { changeRequestStatusStyleArray } from "../../../../NewProjectDetails/config";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

export default function ChangeRequestBudgets({ data }) {
  const budgetItems = data?.newMilestoneDetails?.proposalBudgetItems;
  const [selectedBudget, setSelectedBudget] = useState(null);
  const handleClick = (item) => {
    console.log("item", item);
    setSelectedBudget(item);
  };

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "none !important",
          boxShadow: "none",
          maxHeight: "67vh",
          marginTop: "2vh",
          scrollbarWidth: "none",
        }}
      >
        <Table
          sx={{
            "& thead": {
              "& th": {
                color: "#949DAA",
                fontWeight: "500",
              },
            },
            "& tbody": {
              "& tr:hover": {
                backgroundColor: "#f7f7f7",
              },
              "& tr": {
                borderBottom: "none",
              },
            },
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Item</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>
                <strong
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  Unit Cost ({renderCurrencyIcon('small')})
                </strong>
              </StyledTableCell>{" "}
              <StyledTableCell>Units</StyledTableCell>
              <StyledTableCell>Manpower Rate</StyledTableCell>
              <StyledTableCell>Days</StyledTableCell>
              <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                <strong
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  Total Cost ({renderCurrencyIcon('small')})
                </strong>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {budgetItems?.map((item) => (
              <TableRow key={`budget-${item.proposalBudgetId}`}>
                <StyledTableCell
                  style={{
                    flex: 1.5,
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(item)}
                >
                  <Box display="flex" alignItems="center">
                    <Box
                      component="img"
                      src={
                        !isEmpty(item?.buget_image)
                          ? item?.buget_image[0]?.image
                          : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                      }
                      alt="Project Icon"
                      sx={{
                        width: 45,
                        height: 45,
                        borderRadius: "8px",
                        border: "2px solid white",
                        boxShadow: "0px 4px 2.67px 0px #00000026",
                        marginRight: 1,
                      }}
                    />
                    {item?.name}
                  </Box>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        border: "3px solid rgb(229, 229, 229)",
                        backgroundColor:
                          changeRequestStatusStyleArray.find(
                            (style) => style.status === item?.status
                          )?.backgroundColor || "#FFAD5C",
                      }}
                    ></div>
                    <div style={{ fontSize: "14px", color: "#0D0D0E" }}>
                      {getStatusDisplayText(
                        item?.status === "edited" ? "updated" : item?.status
                      )}
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  {item?.materialUnitPrice
                    ? formattedAmountWithoutAed(item?.materialUnitPrice)
                    : "-"}
                </StyledTableCell>
                <StyledTableCell>
                  {item?.quantity !== null ? item.quantity : "-"}
                </StyledTableCell>
                <StyledTableCell>{item?.manpowerRate || "-"}</StyledTableCell>
                <StyledTableCell>{item?.days || "-"}</StyledTableCell>
                <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                  {formattedAmountWithoutAed(item?.totalPrice)}
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* {selectedBudget && (
        <BudgetItemModal
          selectedBudget={selectedBudget}
          setSelectedBudget={setSelectedBudget}
        />
      )} */}
    </>
  );
}
